<template>
  <div>
    <el-form
      :model="formParams"
      class="elFormClass"
      ref="ruleForm"
      size="small"
      label-width="auto"
    >
      <div class="flex_between_wrap">
        <div v-for="(item, index) in formItem" :key="index" style="width:46%">
          <el-form-item
            :label="item.label"
            :rules="item.rules ? formRules[item.rules] : formRules.not"
            :prop="item.model"
          >
            <el-cascader
            popper-class="popperCascader" 
              style="width:100%"
              ref="cascaderArr"
              :placeholder="'请选择' + item.label"
              v-if="item.model == 'deptId'"
              v-model="formParams[item.model]"
              :options="cascaderArr"
              :show-all-levels="false"
              @change="handleChange"
              :props="{
                expandTrigger: 'hover',
                value: 'id',
                label: 'deptName',
                emitPath: false,
                checkStrictly: true,
              }"
            ></el-cascader>

            <el-select
              style="width:99%"
              clearable
              @change="selectChange"
              v-model="formParams[item.model]"
              v-else-if="item.model == 'roleId'"
              :placeholder="'请选择' + item.label"
            >
              <el-option
                v-for="item in roleArr"
                :key="item.id"
                :label="item.roleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              style="width:99%"
              clearable
              v-model="formParams[item.model]"
              v-else-if="item.model == 'workStatus'"
              :placeholder="'请选择' + item.label"
            >
              <el-option
                v-for="o in item.options"
                :key="o.model"
                :label="o.label"
                :value="o.model"
              >
              </el-option>
            </el-select>

            <el-cascader
            popper-class="popperCascader" 

              style="width:99%"
              ref="cascaderArr"
              collapse-tags
              clearable
              placeholder="不选择则拥有全部权限"
              v-else-if="item.model == 'dataScope'"
              v-model="formParams[item.model]"
              :options="cascaderArr"
              :show-all-levels="false"
              :props="{
                expandTrigger: 'hover',
                value: 'id',
                label: 'deptName',
                emitPath: false,
                multiple: true,
                checkStrictly: true,
              }"
            ></el-cascader>
            <el-input
              clearable
              :show-password="item.model=='pwd'?true:false"
              v-else
              :placeholder="'请输入' + item.label"
              size="small"
              v-model="formParams[item.model]"
            ></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="dialog_bottom">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    callBack: Function,
    row: Object,
    deptId: String,
  },
  data() {
    return {
      cascaderArr: [],
      roleArr: [],
      formParams: {
        workStatus: "working",
        pwd:"888888"
      },
      menuArr: [],
      formItem: [
        {
          label: "员工姓名",
          model: "staffName",
          rules: "requiredChange",
        },
        {
          label: "工号",
          model: "jobNumber",
          rules: "requiredChange",
        },

        {
          label: "组织",
          model: "deptId",
          rules: "requiredChange",
          type: "cascader",
        },
        {
          label: "职务",
          model: "position",
        },
        {
          label: "手机",
          model: "phoneNumber",
        },
        {
          label: "角色",
          model: "roleId",
        },

        {
          label: "账号",
          model: "accountName",
        },
        {
          label: "权限范围",
          model: "dataScope",
        },
        {
          label: "状态",
          model: "workStatus",
          rules: "requiredChange",

          options: [
            {
              label: "在职",
              model: "working",
            },
            {
              label: "离职",
              model: "dimission",
            },
          ],
        },
        {
          label: "登陆密码",
          model: "pwd",

        },
      ],
    };
  },
  mounted() {},
  methods: {
    selectChange(data) {
      if(data){
           for (let i = 0; i < this.roleArr.length; i++) {
        if (this.roleArr[i].id == data) {
          this.$set(this.formParams, "roleName", this.roleArr[i].roleName);
          break;
        }
      }
      }else{
          this.$set(this.formParams, "roleName", '');
        
      }
    },
    handleChange(data) {
      setTimeout(() => {
        this.$set(
          this.formParams,
          "deptName",
          this.$refs["cascaderArr"][0].getCheckedNodes()[0].data.deptName
        );
      });
    },
    init() {
      if (this.row.id) {
        this.formParams = JSON.parse(JSON.stringify(this.row));
        this.formParams.dataScope = this.formParams.dataScope.split(",");
      } else {
        /* 获取编号 */

        this.$requestAxios(
          {
            url: "/pc/admin/get_code",
            data: {},
          },
          (data) => {
            this.$set(this.formParams, "jobNumber", data.data);
          }
        );
      }
      /*选择组织 权限范围 */

      this.$requestAxios(
        {
          url: "/pc/dept/tree",
          data: {},
        },
        (data) => {
          this.$treeChildrenEmp(data.data);
          this.cascaderArr = data.data;
          if (!this.row.id) {
            if (this.deptId) {
              this.$set(this.formParams, "deptId", this.deptId);

              this.handleChange(this.deptId);
            }
          }
        }
      );
      /* 角色选择 */

      this.$requestAxios(
        {
          url: "/pc/role/page",
          data: {},
        },
        (data) => {
          this.roleArr = data.data;
        }
      );
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let submit = JSON.parse(JSON.stringify(this.formParams));
          if( submit.dataScope){
          submit.dataScope = submit.dataScope.join();

          }
          this.$requestAxiosForm(
            {
              url: "/pc/admin/add_update",
              data: submit,
            },
            (data) => {
              this.$success();
              this.callBack();

              this.closeDialog();
            }
          );
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>

</style>
